var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 5.5H14.8672M6.12449 5.40587L6.12449 14.3281M11.5444 5.40587V14.3281M3.05698 14.3281C2.68033 14.3281 2.375 14.0191 2.375 13.6378V2.34663C2.375 1.96534 2.68033 1.65625 3.05698 1.65625H14.4432C14.8199 1.65625 15.1252 1.96534 15.1252 2.34663C15.1252 2.34663 15.1252 13.2565 15.1252 13.6378C15.1252 14.0191 14.8199 14.3281 14.4432 14.3281C14.0666 14.3281 9.82604 14.3281 9.82604 14.3281H3.05698Z",
    stroke: "black",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/Table.21d2c37cfcf736580f7cd1ba667cc95c.svg";
export { ForwardRef as ReactComponent };